import { safeInit } from "./includes/utils";
import ProductInformations from "./includes/_product-informations.class";
import NavigationHistory from "./includes/_navigationHistory.class";
import Layer from "@mozaic-ds/freemarker/js/modules/_layer";
import { isElementLowerThanThreshold } from "./includes/elementThreshold.tools";
import InstallmentPayments from "./includes/installment-payments";
import { addToCart } from "./includes/_atc";
import initOffers from "./includes/_offers";
import initPopin from "./includes/_popin";
import { initChangeStoreLink, initChangeStoreLinkWithStock } from "./includes/_change-store";
import setLayer from "./includes/_layer";
import setCheckedRadio from "./includes/_setCheckedRadio";
import initQuantitySelector from "./includes/_quantity-selector";
import RagProductDetail from "./includes/_rag-productdetail.class";
if (typeof __webpack_public_path__ !== "undefined") {
  __webpack_public_path__ = "/static/";
}
export default class ProductDetail extends lm.Composant {
  constructor(id) {
    super(id);
    const productDetailSelector = "#product-detail";
    const component = document.querySelector(productDetailSelector);
    if (!component) {
      return;
    }

    // product part

    safeInit("accordion", () => {
      const productInformationElement = component.querySelector("#product-informations");
      if (productInformationElement) {
        const productInformationsInstance = new ProductInformations(productInformationElement);
        productInformationsInstance.initAccordion();
      }
    });
    safeInit("rag-productdetail", () => {
      const mainRag = component.querySelector(".o-ragProductDetail");
      if (mainRag) {
        const rag = new RagProductDetail(component);
        rag.initRag();
      }
    });
    safeInit("carousel", () => {
      const mainCarousel = component.querySelector("#product-carousel");
      if (mainCarousel) {
        import(/* webpackChunkName: "productCarousel" */"./includes/_productCarousel.class").then(module => new module.default(mainCarousel)).catch(console.error);
      }
    });
    safeInit("gallery", () => {
      const mainGallery = component.querySelector('#product-gallery');
      if (mainGallery) {
        import(/* webpackChunkName: "productGallery" */"./includes/_productGallery.class").then(module => new module.default(mainGallery)).catch(console.error);
      }
    });
    safeInit("media-zoom", () => {
      const mediaZoom = component.querySelector("#media-zoom");
      if (mediaZoom) {
        import(/*webpackChunkName: "mediaZoom" */"./includes/mediaZoom/_mediaZoom.class").then(module => new module.default(mediaZoom)).catch(console.error);
      }
    });
    safeInit("video", () => {
      const videos = component.querySelectorAll('.video-js');
      if (videos) {
        import(/* webpackChunkName: "video" */'./../legacy/_video.class').then(module => {
          new module.default();
        }).catch(console.error);
      }
    });
    safeInit("layers", () => {
      [{
        'button': '#js-f-gas-legals',
        'layer': 'js-layer-f-gas'
      },
      // F-Gas
      {
        'button': '.js-take-back-layer-button',
        'layer': 'js-take-back-layer'
      },
      // Take Back
      {
        'button': '.js-energy-popin-opener',
        'layer': 'js-energy-popin'
      } // Energy
      ].forEach(config => {
        const buttonEl = component.querySelector(config.button);
        if (buttonEl) {
          const layer = new Layer({
            'classContent': config.layer
          });
          buttonEl.addEventListener('click', () => layer.open());
        }
      });
    });
    safeInit("second-life", () => {
      const secondLife = component.querySelector(".m-secondLife");
      if (secondLife) {
        const refererElement = secondLife.querySelector('.js-content-wrapper');
        const button = secondLife.querySelector('.js-btn-showSecondLifeText');
        const THRESHOLD = 50;
        if (refererElement && !isElementLowerThanThreshold(refererElement, THRESHOLD)) {
          button.classList.remove('kl-hidden');
          button.addEventListener('click', () => {
            refererElement.setAttribute('data-expanded', `${(refererElement.getAttribute('data-expanded') !== 'true').toString()}`);
            button.setAttribute('aria-expanded', `${(button.getAttribute('aria-expanded') !== 'true').toString()}`);
          });
        }
      }
    });
    safeInit("json-ld-product", () => {
      const jsonLds = component.querySelectorAll('.js-json-ld-container script.dataJsonLd');
      if (jsonLds?.length > 0) {
        for (let jsonLd of jsonLds) {
          const jsonLdData = JSON.parse(jsonLd.innerHTML);
          window.MetaTagEventBus.emit('jsonLdTrigger', {
            data: jsonLdData
          });
        }
      }
    });

    // offer part

    safeInit("main-add-to-cart", () => {
      const form = component.querySelector(".js-add-to-cart-pdp-form");
      if (form) {
        form.addEventListener('submit', addToCart.bind(this, form));
      }
    });
    safeInit("other-add-to-cart", () => {
      const forms = component.querySelectorAll(".js-add-to-cart-form");
      if (forms) {
        initOffers(this, forms);
      }
    });
    safeInit("change-store", () => {
      const links = component.querySelectorAll(".js-delivery-store-link");
      if (links) {
        initChangeStoreLink(links);
      }
    });
    safeInit("change-store-with-stock", () => {
      const links = component.querySelectorAll(".js-choose-store-stock");
      if (links) {
        initChangeStoreLinkWithStock(links);
      }
    });
    safeInit("quantity-selector", () => {
      const forms = component.querySelectorAll(".js-quantity-selector-form");
      for (let i = 0; i < forms.length; i++) {
        initQuantitySelector(component, forms[i]);
      }
    });
    safeInit("ecopart-popin", () => {
      const buttons = component.querySelectorAll(".js-popin-deee__button");
      if (buttons) {
        initPopin(buttons);
      }
    });
    safeInit("second-life-popin", () => {
      const buttons = component.querySelectorAll(".js-popin-refurbished__button");
      if (buttons) {
        initPopin(buttons);
      }
    });
    safeInit("non-recoverable-vat-popin", () => {
      const buttons = component.querySelectorAll(".js-popin-non-recoverable-vat__button");
      if (buttons) {
        initPopin(buttons);
      }
    });
    safeInit("installments", () => {
      const oneyButton = component.querySelector('.js-triggerOney');
      const paypalButton = component.querySelector('.js-triggerPaypal');
      if (oneyButton || paypalButton) {
        const installmentPayments = new InstallmentPayments();
        if (oneyButton) installmentPayments.installment0ney(oneyButton);
        if (paypalButton) installmentPayments.installmentPaypal(paypalButton);
      }
    });
    safeInit("installation-package", () => {
      const offerRadioButtons = component.querySelectorAll("input.js-offer-radio");
      setCheckedRadio(offerRadioButtons, "li.js-offer-radio");
      const reduceVatLayer = component.querySelector(".js-reducedvat-layer-button");
      setLayer(this, reduceVatLayer, 'js-reducedvat-layer');
      const ctaTva = component.querySelector(`.js-reducedvat-layer .js-layer-first-cta`);
      if (ctaTva) {
        ctaTva.addEventListener('click', () => {
          const {
            link
          } = ctaTva.dataset;
          if (link) {
            window.open(link, '_blank');
          }
        });
      }
    });
    safeInit("delivery-layer", () => {
      const layerDeliveryButton = component.querySelector('.js-delivery-layer-button');
      setLayer(this, layerDeliveryButton, 'js-layer-all-delivery-mode');
    });
    safeInit("tracking-event", () => {
      const elemToTrack = component.querySelectorAll('.js-event-cdl');
      elemToTrack.forEach(elm => {
        elm.addEventListener('click', e => {
          const {
            eventName,
            eventData
          } = e.target.dataset;
          if (eventName && eventData) {
            this.hitCdlEventTracking(eventName, eventData);
          }
        });
      });
    });
  }
  hitCdlEventTracking(eventName, eventData) {
    const jsonEvents = JSON.parse(eventData.replaceAll('\'', '"'));
    if (typeof tC.event === 'object') {
      return tC.event.cdl_event(this, {
        'event_name': eventName,
        'event_data': jsonEvents
      });
    }
  }
}
lm.DOMReady(function () {
  new ProductDetail("productdetail");
  new NavigationHistory();
});